interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 sm:py-4 relative">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className={`transition-all duration-300`}>
              <img 
                src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/dbc53194c4c8ba8a3a933df42f281e45.png" 
                alt="Beaulieu Dental - Anxiety-Friendly Dentist Chelmsford" 
                title="Beaulieu Dental - Gentle Dental Care for Anxious Patients"
                className="h-[100px] w-[100px] sm:h-[120px] sm:w-[120px] md:h-[150px] md:w-[150px] object-contain drop-shadow-lg"
              />
            </div>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('features')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-[#444c42] hover:text-[#d0a24f]' : 'text-white hover:text-[#d0a24f] drop-shadow-lg'
            }`}>
              Our Services
            </button>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-[#444c42] hover:text-[#d0a24f]' : 'text-white hover:text-[#d0a24f] drop-shadow-lg'
            }`}>
              Meet Our Team
            </button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-[#444c42] hover:text-[#d0a24f]' : 'text-white hover:text-[#d0a24f] drop-shadow-lg'
            }`}>
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-[#444c42] hover:text-[#d0a24f]' : 'text-white hover:text-[#d0a24f] drop-shadow-lg'
            }`}>
              Contact
            </button>
            <a 
              href="https://beaulieudental.co.uk/book-free-consultation/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#d0a24f] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#dcb964] transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Free Consultation
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}